<template>
  <div id="ScreenFirst">
    <c-block-box title="语音" class="first-floor-item-1">
      <div class="content">
        <div class="left-content">
          <div class="lists-wrap">
            <div class="item" v-for="(item,index) in firstFloorFlists">
              <p class="name">{{ item.name }}</p>
              <span class="count BoldAlternate">{{ numberSplitWithComma(item.count) }}</span>
              <div class="super-name-wrap" v-if="[0,3].includes(index)&&checkUndefineAndNull(item.superCount)">
                <span class="super-name">本月新增</span>
                <span class="super-count">{{ item.superCount>=0?'+':'' }}{{ numberSplitWithComma(item.superCount) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="item-wrap">
            <p class="item-warp-title">总趋势</p>
            <DomeEchartWrap ref="total-call-trend" id="total-call-trend"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">日调用趋势</p>
            <DomeEchartWrap ref="day-call-trend" id="day-call-trend"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">日活跃用户量</p>
            <DomeEchartWrap ref="DailyActiveUsersEchartOp" id="DailyActiveUsersEchartOp"></DomeEchartWrap>
          </div>
          <div class="item-wrap item-wrap-ld">
            <p class="item-warp-title">语音转化漏斗</p>
            <DomeEchartWrap ref="SpeechConversionFunnel" id="SpeechConversionFunnel"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">方言数据</p>
            <DomeEchartWrap ref="DialectData" id="DialectData"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">高频词</p>
            <DomeEchartWrap ref="HighFrequencyWords" id="HighFrequencyWords"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </c-block-box>
    <c-block-box title="联动屏" class="first-floor-item-2">
      <div class="content">
        <div class="left-content">
          <div class="lists-wrap">
            <div class="item" v-for="item in secondFloorFlists" :key="item.count">
              <p class="name">{{ item.name }}</p>
              <span class="count BoldAlternate">{{ numberSplitWithComma(item.count) }}</span>
              <div class="super-name-wrap" v-if="checkUndefineAndNull(item.superCount)">
                <span class="super-name">本月新增</span>
                <span class="super-count">{{ item.superCount>=0?'+':'' }}{{ numberSplitWithComma(item.superCount) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="item-wrap">
            <p class="item-warp-title">主要功能使用排名</p>
            <DomeEchartWrap ref="RankingMainFunctions" id="RankingMainFunctions"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">视频通话</p>
            <ScreenFirstFloorSecondItem :item-lists="videoToLists">
              <DomeEchartWrap ref="VideoCall" id="VideoCall"></DomeEchartWrap>
            </ScreenFirstFloorSecondItem>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">投屏</p>
            <ScreenFirstFloorSecondItem :item-lists="touPingLists">
              <DomeEchartWrap ref="ProjectionScreen" id="ProjectionScreen"></DomeEchartWrap>
            </ScreenFirstFloorSecondItem>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">家庭看护</p>
            <ScreenFirstFloorSecondItem :item-lists="familyWatchLists">
              <DomeEchartWrap ref="HomeCare" id="HomeCare"></DomeEchartWrap>
            </ScreenFirstFloorSecondItem>
          </div>
        </div>
      </div>
    </c-block-box>
    <c-block-box title="MIITEE" class="first-floor-item-3">
      <div class="content">
        <div class="left-content">
          <div class="lists-wrap">
            <div class="item" v-for="(item,index) in threeFloorFlists">
              <p class="name">{{ item.name }}</p>
              <span class="count BoldAlternate">{{ numberSplitWithComma(item.count) }}</span>
              <div class="super-name-wrap" v-if="[0,1].includes(index)&&checkUndefineAndNull(item.superCount)">
                <span class="super-name">本月新增</span>
                <span class="super-count">{{ item.superCount>=0?'+':'' }}{{ numberSplitWithComma(item.superCount) }}</span>
              </div>
              <div class="super-name-wrap" v-if="[1].includes(index)">
                <span class="super-name">环比</span>
                <span class="super-count">{{ item.hb>=0?'+':'' }}{{ numberSplitWithComma(item.hb) }}%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="item-wrap">
            <p class="item-warp-title">会议终端与参会成员数</p>
            <DomeEchartWrap ref="NumberConferenceTerminalsParticipants" id="NumberConferenceTerminalsParticipants"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">会议大屏与文档使用情况</p>
            <DomeEchartWrap ref="ConferenceLargeScreenDocumentUsage" id="ConferenceLargeScreenDocumentUsage"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">会议次数与时长数据</p>
            <DomeEchartWrap ref="NumberDurationMeetings" id="NumberDurationMeetings"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">终端分布</p>
            <DomeEchartWrap ref="ProportionTerminalDistribution" id="ProportionTerminalDistribution"></DomeEchartWrap>
          </div>
          <div class="item-wrap">
            <p class="item-warp-title">地域分布</p>
            <DomeEchartWrap ref="ProportionUrbanDistribution" id="ProportionUrbanDistribution"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </c-block-box>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import { HighFrequencyWordsEchartOp, DialectDataEchartOp, totalCallTrendEchartOp, dayCallTrendEchartOp, DailyActiveUsersEchartOp, SpeechConversionFunnelEchartOp } from './js/FirstFloorItem1'
import { RankingMainFunctionsEchartOp, VideoCallEchartOp, ProjectionScreenEchartOp, HomeCareEchartOp } from './js/FirstFloorItem2'
import { ProportionUrbanDistributionEchartOp, NumberDurationMeetingsEchartOp, ProportionTerminalDistributionEchartOp, NumberConferenceTerminalsParticipantsEchartOp, ConferenceLargeScreenDocumentUsageEchartOp } from './js/FirstFloorItem3.js'
import ScreenFirstFloorSecondItem from './ScreenFirstFloorSecondItem'
export default {
  mixins: [common],
  name: 'ScreenFirst',
  components: {
    DomeEchartWrap,
    ScreenFirstFloorSecondItem
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      firstFloorFlists: [
        {
          name: '总支持量',
          count: 27464890,
          countKey: 'installNum',
          superCount: 0,
          superKey: 'installNewNum'
        },
        {
          name: '激活量',
          count: 20045177,
          countKey: 'activeUserNum'
        },
        {
          name: '活跃量',
          count: 7077351
        },
        {
          name: '总请求量', count: 682686616
        }
      ],
      secondFloorFlists: [
        {
          name: '累计用户数',
          count: 9002827
        },
        {
          name: '活跃用户数',
          count: 72897,
          superCount: 0
        },
        {
          name: '新增用户数',
          count: 3114
        }
      ],
      threeFloorFlists: [
        {
          name: '累计用户数',
          count: 0
        },
        {
          name: '活跃用户数',
          count: 0,
          superCount: 0,
          hb: 0
        },
        {
          name: '新增用户数 ',
          count: 0
        }
      ],
      videoToLists: [
        {
          name: '累计用户数', count: 17858, superCount: 25
        },
        {
          name: '活跃用户数', count: 5629, superCount: 0
        },
        {
          name: '日均通话时长', count: '2分16秒'
        }
      ],
      touPingLists: [
        {
          name: '累计用户数', count: 48292, superCount: 5280
        },
        {
          name: '活跃用户数', count: 22516, superCount: 4020
        }
      ],
      familyWatchLists: [
        {
          name: '累计用户数', count: 17858, superCount: 25
        },
        {
          name: '活跃用户数', count: 5629, superCount: 0
        },
        {
          name: '日均通话时长', count: '2分16秒'
        }
      ]
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      this.$refs['total-call-trend'].setEchartOption(totalCallTrendEchartOp({ v: this }))
      /// //////////////////////////
      this.$refs['RankingMainFunctions'].setEchartOption(RankingMainFunctionsEchartOp({ v: this }))
      this.$refs['VideoCall'].setEchartOption(VideoCallEchartOp({ v: this }))
      this.$refs['ProjectionScreen'].setEchartOption(ProjectionScreenEchartOp({ v: this }))
      this.$refs['HomeCare'].setEchartOption(HomeCareEchartOp({ v: this }))
      /// //////
      this.$refs['ProportionTerminalDistribution'].setEchartOption(ProportionTerminalDistributionEchartOp({ v: this }))
      this.$refs['ProportionUrbanDistribution'].setEchartOption(ProportionUrbanDistributionEchartOp({ v: this }))
    })
  },
  watch: {
    data: {
      deep: true,
      handler: function (newValue, oldValue) {
        let { dayUseChart, dayPeopleChart, fyChar, gpcChar, voiceChar, voiceFunnelVO, ...arg } = newValue?.voiceVO ?? {}
        let { terminalUserCountMap, documentCountMap, frequencyMap, totalUser, activeUser, addActiveUser, activeRate, addUser, lastActiveUser } = newValue?.unboundedMiiteeVO ?? {}
        this.$nextTick(() => {
          this.dayUseChart(dayUseChart)
          this.dayPeopleChart(dayPeopleChart)
          this.fyChar(fyChar)
          this.gpcChar(gpcChar)
          this.voiceChar(voiceFunnelVO)
          this.firstFlists(arg)
          /// ///MIITEE
          this.setTerminalUserCountMap(terminalUserCountMap)
          this.setDocumentCountMap(documentCountMap)
          this.setFrequencyMap(frequencyMap)
          this.setThreeTag({ totalUser, activeUser, addActiveUser, activeRate, addUser, lastActiveUser })
        })
      }
    }
  },
  methods: {
    firstFlists (val) {
      // let { installNum, installNewNum, activeRate, visitNum, asctiveNewUserNum } = val
      this.firstFloorFlists.forEach(item => {
        if (item.countKey) {
          item.count = val[item.countKey] ?? 0
        }
        if (item.superKey) {
          item.superCount = val[item.superKey] ?? 0
        }
      })
    },
    dayUseChart (val) {
      if (!val) { return }
      let data = this.commDayLists(val)
      this.$refs['day-call-trend'].setEchartOption(dayCallTrendEchartOp({ v: this, data }))
    },
    dayPeopleChart (val) { // 日活跃用户量
      if (!val) { return }
      let data = this.commDayLists(val)
      this.$refs['DailyActiveUsersEchartOp'].setEchartOption(DailyActiveUsersEchartOp({ v: this, data }))
    },
    commDayLists (val) {
      let date = []
      let name = []
      let data = []
      name = Object.keys(val)
      date = val[name[0]].date.map(item => item.slice(5)) ?? []
      name.forEach((item) => {
        data.push(val[item].data)
      })
      return {
        date, name, data
      }
    },
    fyChar (val) { // 方言
      if (!val) { return }
      let name = []
      let data = []
      val.forEach((item) => {
        name.unshift(item.dialectName.slice(5))
        data.unshift(item.useCount)
      })
      this.$refs['DialectData'].setEchartOption(DialectDataEchartOp({ v: this, data: { name, data } }))
    },
    gpcChar (val) { // 高频词
      if (!val) { return }
      let list = val.map(item => {
        return {
          value: item.useCount,
          name: item.name
        }
      })
      this.$refs['HighFrequencyWords'].setEchartOption(HighFrequencyWordsEchartOp({ v: this, list }))
    },
    voiceChar (val) { // 漏斗
      if (!val) { return }
      let s = ['asrPv', 'nlpPv', 'sfyPv', 'totalPv']
      let v = {
        asrPv: '听清率',
        nlpPv: '听懂率',
        sfyPv: '满足率'
      }
      let lists = []
      let name = []
      s.forEach((item, index) => {
        lists.push(
          {
            // percent: index === 0 ? 0 : val[index - 1].rate,
            name: val[index - 1]?.dateType ?? '',
            // value: 25 * (index + 1),
            v: val[item],
            key: item
          }
        )
        // if (index === 0) { lists[0].label = { show: false } }
      })
      lists.sort((a, b) => a.v - b.v)
      lists.forEach((item, index) => {
        item.value = 25 * (index + 1)
      })
      lists.forEach((item, index) => {
        name.push(v[item.key])
        item.percent = val[item.key.replace('Pv', '') + 'Rate'] ?? 0
        if (index === 0) { lists[3].label = { show: false } }
      })
      this.$refs['SpeechConversionFunnel'].setEchartOption(SpeechConversionFunnelEchartOp({ v: this,
        data: {
          name,
          lists
        } }))
    },
    setTerminalUserCountMap (val) {
      let tags = ['会议成员', '会议终端']
      let data = {
        name: [...tags],
        date: val?.[tags[0]].date ?? val?.[tags[1]].date ?? [],
        data: tags.map(item => {
          return {
            data: val?.[item]?.data ?? [],
            name: item,
            type: 'line',
            smooth: true,
            symbol: 'none'
          }
        })
      }

      this.$refs['NumberConferenceTerminalsParticipants'].setEchartOption(NumberConferenceTerminalsParticipantsEchartOp({ v: this, data }))
    },
    setDocumentCountMap (val) {
      let tags = ['会议大屏', '会议文档']
      let data = {
        name: [...tags],
        date: val?.[tags[0]].date ?? val?.[tags[1]].date ?? [],
        data: tags.map(item => {
          return {
            data: val?.[item]?.data ?? [],
            name: item
          }
        })
      }
      this.$refs['ConferenceLargeScreenDocumentUsage'].setEchartOption(ConferenceLargeScreenDocumentUsageEchartOp({ v: this, data }))
    },
    setFrequencyMap (val) {
      let tags = ['会议次数', '会议时长']
      let data = {
        name: [...tags],
        date: val?.[tags[0]].date ?? val?.[tags[1]].date ?? [],
        data: tags.map(item => {
          return {
            data: val?.[item]?.data ?? [],
            name: item
          }
        })
      }
      this.$refs['NumberDurationMeetings'].setEchartOption(NumberDurationMeetingsEchartOp({ v: this, data }))
    },
    setThreeTag ({ totalUser, activeUser, addActiveUser, activeRate, addUser, lastActiveUser }) {
      let val = this.threeFloorFlists
      val[0].count = totalUser
      val[1].count = activeUser
      val[1].superCount = addActiveUser
      val[1].hb = activeRate
      val[2].count = addUser
    }
  }
}
</script>

<style scoped lang="stylus">
#ScreenFirst
  color: rgba(255, 255, 255, 0.8)
.content
  padding 1.6rem 0 1.6rem 1rem
  height 21rem
  display flex
  .name
    font-size: 1.04rem
    margin-bottom: .4rem
  .count
    font-size: 1.56rem
    display inline-block
    height: 1.8rem
    line-height: 1.8rem
  .super-name-wrap
    font-size: .8rem
    margin-top: .3rem
    .super-name
      color rgba(255, 255, 255, 0.6)
    .super-count
      color rgba(24, 105, 255, 1)
      margin-left: .25rem
  .left-content
    border-right: 0.12rem solid rgba(255, 255, 255, 0.1)
    width 12rem
  .lists-wrap
    height 100%
    display: flex
    flex-direction: column
    justify-content: space-between
    .item
      display: flex
      flex-direction: column
      justify-content: space-between

>>>
  .unit-header
    font-size: 1.52rem
    padding-left: 1rem
    height 3rem
    line-height: 3rem

.right-content
  display: flex
  justify-content: space-between
  padding 0 2rem
  flex-grow: 1
  .item-wrap
    display: flex
    flex-direction: column
    height: 100%

.first-floor-item-1
  .right-content
    .item-wrap
      width 16.15rem
    .item-wrap-ld
      width 17rem
.first-floor-item-2
  .right-content
    .item-wrap
      width 25.25rem

.first-floor-item-3
  .right-content
    .item-wrap
      width 19.6rem

.first-floor-item-2,.first-floor-item-1
  margin-bottom: 2rem

.item-warp-title
  padding-bottom: 1.5rem
  flex-shrink: 0
</style>
